/** Registry statuses that indicate the company is in good standing (shown in green). */
const POSITIVE_REGISTRY_COMPANY_STATUSES = new Set([
  "active",
  "aktiv",
  "registrert",
  "registered",
]);

export function isPositiveRegistryCompanyStatus(status: unknown): boolean {
  const s = (typeof status === "string" ? status : status == null ? "" : String(status))
    .toLowerCase()
    .trim();
  if (!s) return false;
  if (POSITIVE_REGISTRY_COMPANY_STATUSES.has(s)) return true;
  if (s.startsWith("valid")) return true;
  return false;
}

export function registryCompanyStatusTextColor(
  status: unknown,
  anonymousView: boolean
): string | undefined {
  if (anonymousView) return undefined;
  return isPositiveRegistryCompanyStatus(status) ? "green.7" : "red.7";
}
